import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

const isDev = typeof process !== 'undefined'
  ? process.env.NODE_ENV === 'development'
  : typeof import.meta !== 'undefined' && import.meta.env?.DEV;

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: isDev,
    fallbackLng: 'fr',
    supportedLngs: ['en', 'fr'],
    detection: {
      // SECURITE : on utilise 'cookie' au lieu de 'localStorage' pour la
      // préférence de langue. sessionStorage n'est pas supporté nativement
      // par i18next-browser-languagedetector — cookie est le meilleur
      // équivalent non-localStorage. La langue n'est pas une donnée sensible
      // mais on évite d'utiliser localStorage par cohérence avec la politique
      // de stockage du projet (tout en sessionStorage ou cookie).
      order:  ['cookie', 'navigator'],
      caches: ['cookie'],
      cookieOptions: {
        // SameSite=Strict protège contre le CSRF.
        // Pas HttpOnly car i18next doit lire ce cookie depuis JS.
        sameSite: 'Strict',
        path: '/',
      },
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
